const formatarMoedaBrasileiraPct = (v) => `${(v ?? 0).toFixed(1)}%`;

const C = {
    bg: "#F0F4F8",
    surface: "#FFFFFF",
    surfaceAlt: "#F8FAFC",
    border: "#E2E8F0",
    borderStrong: "#CBD5E1",
    primary: "#0EA5E9",
    primaryDark: "#0284C7",
    secondary: "#6366F1",
    accent: "#10B981",
    danger: "#EF4444",
    warn: "#F59E0B",
    purple: "#8B5CF6",
    text: "#0F172A",
    textMid: "#475569",
    muted: "#94A3B8",
    c1: "#0EA5E9",
    c2: "#6366F1",
    c3: "#10B981",
    c4: "#F59E0B",
    c5: "#EF4444",
};

export function KPICard({ label, value, title, pct, color, icon, sub, loading }) {
    return (
        <div style={{
            background: C.surface, border: `1px solid ${C.border}`,
            borderRadius: 14, padding: "18px 20px", position: "relative", overflow: "hidden",
            boxShadow: "0 1px 4px rgba(15,23,42,.06)",
        }}>
            <div style={{
                position: "absolute", top: 0, right: 0,
                width: 72, height: 72, borderRadius: "0 14px 0 72px",
                background: `${color}12`,
                display: "flex", alignItems: "flex-start", justifyContent: "flex-end",
                padding: "10px 12px", fontSize: 20,
            }}>{icon}</div>
            <div style={{ fontSize: 11, color: C.muted, textTransform: 'uppercase', letterSpacing: .8, marginBottom: 8, fontWeight: 600 }}>
                {label}
            </div>
            {loading ? (
                <div style={{ height: 31.5, background: C.border, borderRadius: 6, width: "70%", animation: "pulse 1.5s infinite" }} />
            ) : (
                <div title={title} className="cursor-default font-display" style={{ fontSize: 21, fontWeight: 700, color: C.text, letterSpacing: -0.5 }}>
                    {value}
                </div>
            )}
            {pct !== undefined && !loading && (
                <div style={{
                    display: "inline-flex", alignItems: "center", gap: 4,
                    marginTop: 6, fontSize: 12, fontWeight: 600,
                    color: color, background: `${color}15`, padding: "2px 8px", borderRadius: 20,
                }}>
                    {formatarMoedaBrasileiraPct(pct)}
                </div>
            )}
            {sub &&
                <>{loading ? (
                    <div style={{ height: 12.5, background: C.border, borderRadius: 6, marginTop: '10px', width: "50%", animation: "pulse 1.5s infinite" }} />
                ) : (
                    <div style={{ fontSize: 11, color: C.textMid, marginTop: 4 }}>{sub}</div>
                )}
                </>
            }
        </div>
    );
}